import { defineMessages } from 'react-intl';

const messages = defineMessages({
  removeHold: {
    defaultMessage: 'Remove Hold',
    id: '6IUoUc',
    description: 'Title of button and modal to allow users to remove hold from fulfillment plan',
  },
  removeHoldModalContent: {
    defaultMessage:
      'This order will be moved to the Awaiting Shipment status. This will only affect the order status in ShipStation. You may need to take further action in your online marketplace.',
    id: 'oSxiY8',
    description: 'Remove hold modal content',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'd7x29l',
    description: 'Cancel button text for the remove hold modal',
  },
  errorNotificationTitle: {
    defaultMessage: 'Error Saving Date',
    id: 'wAPoQz',
    description: 'title on error notification when there is an error persisting the date',
  },
  errorNotificationBody: {
    defaultMessage: 'We encountered an issue saving the date. Please try again.',
    id: 'R1lwFA',
    description: 'description of what went wrong when trying to save a date from the order details section',
  },
});
export default messages;
